import Phaser from 'phaser';

export default {
  autoFocus: true,
  transparent: true,
  type: Phaser.AUTO,
  physics: {
    default: 'arcade',
    arcade: {
      debug: false,
      gravity: { y: 300 },
    },
  },
  dom: {
    createContainer: true,
  },
  scene: [],
};
